/** Lightweight reachability check — bypasses axios/offline interceptors. */
export function buildConnectivityProbeUrl(): string {
  const backendOrigin = import.meta.env.VITE_BACKEND_URL?.replace(/\/$/, "") ?? "";
  const apiBase = backendOrigin ? `${backendOrigin}/api` : "/api";
  return `${apiBase}/auth/antiforgery`;
}

export async function probeApiReachability(timeoutMs = 5000): Promise<boolean> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(buildConnectivityProbeUrl(), {
      method: "GET",
      credentials: "include",
      cache: "no-store",
      signal: controller.signal,
    });

    // Any HTTP response means the API is reachable (including 401/403).
    return response.status > 0;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeout);
  }
}
